import { SearchTerm } from './SearchTerm';

const AccessTimePatternSearch: SearchTerm [] = [
    {
        heading: 'Name',
        accessor: 'name',
        searchOnName: 'atpName',
        translationKey: "name"
    },
    {
        heading: "Site",
        accessor: "site",
        searchOnName: "site.siteName",
        translationKey: "site"
    }
];

export default AccessTimePatternSearch;

